<template>
  <div>
    <div class="overflow-hidden">
      <div class="float-left" style="width: 128px; overflow-y: auto">
        <div
          class="pt-6"
          :style="
            store.getters.getConfig.is_header
              ? 'min-height: calc(100vh - 135px)'
              : 'min-height: calc(100vh - 115px)'
          "
        >
          <Menu :selectedKeys="[2]"></Menu>
        </div>
      </div>
      <div class="float-right" style="width: calc(100% - 128px)">
        <div class="p-6 pb-0">
          <a-alert
            v-if="info.review == 1"
            message="审核中"
            class="w-1/2"
            type="warning"
            show-icon
          />
          <a-alert
            v-if="info.review == 3"
            message="驳回意见"
            class="w-1/2"
            :description="info.review_reason"
            type="error"
            show-icon
          />
          <a-alert
            v-if="info.review == 2"
            message="认证成功"
            class="w-1/2"
            type="success"
            show-icon
          />
        </div>
        <a-anchor :offsetTop="64">
          <div class="p-6 bg-white border-b border-gray-200 border-solid">
            <a-button type="primary" v-if="disabled" @click="disabled = false" icon="form">
              {{ info.review == 2 ? '修改个人信息' : '修改' }}</a-button
            >
            <template v-else>
              <a-button v-if="info.id > 0" type="default" @click="cancel" class="mr-4" icon="undo"
                >取消修改</a-button
              >
              <a-button type="primary" @click="submit" icon="save" :loading="btnLoading">
                提交</a-button
              >
            </template>
            <a-button type="primary" class="ml-4" @click="visible = true"> 修改密码 </a-button>
          </div>
        </a-anchor>
        <a-spin :spinning="spinning">
          <div :style="{ width: '500px' }" class="pt-6">
            <a-form :form="form" v-bind="formItemLayout">
              <a-form-item label="昵称">
                <a-textarea
                  v-decorator="[
                    'name',
                    {
                      rules: [{ required: !disabled, message: '请输入昵称' }],
                    },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <!-- <a-form-item label="身份证人像面">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'id_card',
                      {
                        rules: [{ required: !disabled, message: '请上传身份证人像面' }],
                      },
                    ]"
                  ></a-input>
                  <Upload :disabled="disabled" :src="info.id_card" @upload="cardUpload"></Upload>
                </div>
              </a-form-item>
              <a-form-item label="身份证国徽面">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'id_card_back',
                      {
                        rules: [{ required: !disabled, message: '请上传身份证国徽面' }],
                      },
                    ]"
                  ></a-input>
                  <Upload
                    :disabled="disabled"
                    :src="info.id_card_back"
                    @upload="cardBackUpload"
                  ></Upload>
                </div>
              </a-form-item> -->
              <a-form-item label="开户行">
                <a-textarea
                  v-decorator="[
                    'bank_name',
                    {
                      rules: [{ required: false, message: '请输入开户行' }],
                    },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="银行账号">
                <a-textarea
                  v-decorator="[
                    'bank_account',
                    {
                      rules: [{ required: false, message: '请输入银行账号' }],
                    },
                  ]"
                  :disabled="disabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
            </a-form>
          </div>
        </a-spin>
      </div>
      <div class="float-right" style="width: calc(100% - 128px)">
        <div class="p-6 pb-0" v-if="companyinfo.status_id > 0">
          <a-alert
            v-if="companyinfo.status_id == 1"
            message="审核中"
            class="w-1/2"
            type="warning"
            show-icon
          />
          <a-alert
            v-if="companyinfo.status_id == 3"
            message="驳回意见"
            class="w-1/2"
            :description="companyinfo.review_reason"
            type="error"
            show-icon
          />
          <a-alert
            v-if="companyinfo.status_id == 2"
            message="认证成功"
            class="w-1/2"
            type="success"
            show-icon
          />
        </div>
        <div class="p-6">
          <a-button
            type="primary"
            v-if="companydisabled"
            @click="companydisabled = false"
            icon="form"
          >
            {{ companyinfo.status_id == 2 ? '修改企业认证' : '修改' }}</a-button
          >
          <div v-else>
            <a-button
              v-if="companyinfo.id > 0"
              type="default"
              @click="cancel"
              class="mr-4"
              icon="undo"
              >取消修改</a-button
            >
            <a-button type="primary" @click="companysubmit" icon="save" :loading="btnLoading">
              提交</a-button
            >
          </div>
        </div>
        <a-spin :spinning="spinning">
          <div :style="{ width: '500px' }" class="pt-6">
            <a-form :form="companyform" v-bind="formItemLayout">
              <a-form-item label="营业执照">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'license',
                      {
                        rules: [{ required: !companydisabled, message: '请上传营业执照' }],
                      },
                    ]"
                  ></a-input>
                  <Upload
                    :disabled="companydisabled"
                    :src="companyinfo.license"
                    @upload="licenseUpload"
                  ></Upload>
                </div>
              </a-form-item>
              <a-form-item label="开户许可证">
                <div class="overflow-hidden">
                  <a-input
                    v-show="false"
                    v-decorator="[
                      'certificate_src',
                      {
                        rules: [{ required: !companydisabled, message: '请上传开户许可证' }],
                      },
                    ]"
                  ></a-input>
                  <Upload
                    :disabled="companydisabled"
                    :src="companyinfo.certificate_src"
                    @upload="companycertUpload"
                  ></Upload>
                </div>
              </a-form-item>
              <a-form-item label="资质证书">
                <div class="overflow-hidden">
                  <a-input v-show="false" v-decorator="['qualification_src']"></a-input>
                  <Upload
                    :disabled="companydisabled"
                    :src="companyinfo.qualification_src"
                    @upload="qUpload"
                  ></Upload>
                </div>
              </a-form-item>
              <a-form-item label="企业名称">
                <a-textarea
                  v-decorator="[
                    'owner',
                    { rules: [{ required: !companydisabled, message: '请输入企业名称' }] },
                  ]"
                  :disabled="companydisabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="社会信用代码">
                <a-textarea
                  v-decorator="[
                    'taxNumber',
                    {
                      rules: [{ required: !companydisabled, message: '请输入社会信用代码' }],
                    },
                  ]"
                  :disabled="companydisabled"
                  autoSize
                ></a-textarea> </a-form-item
              ><a-form-item label="法人代表">
                <a-textarea
                  v-decorator="[
                    'legal_person',
                    { rules: [{ required: !companydisabled, message: '请输入法人代表' }] },
                  ]"
                  :disabled="companydisabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="地址">
                <a-textarea
                  v-decorator="[
                    'address',
                    { rules: [{ required: !companydisabled, message: '请输入地址' }] },
                  ]"
                  :disabled="companydisabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="开户行">
                <a-textarea
                  v-decorator="[
                    'bankName',
                    { rules: [{ required: !companydisabled, message: '请输入开户行' }] },
                  ]"
                  :disabled="companydisabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="开户企业名称">
                <a-textarea
                  v-decorator="[
                    'name',
                    {
                      rules: [{ required: !companydisabled, message: '请输入开户企业名称' }],
                    },
                  ]"
                  :disabled="companydisabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="开户行账号">
                <a-textarea
                  v-decorator="[
                    'bankAccount',
                    {
                      rules: [{ required: !companydisabled, message: '请输入开户行账号' }],
                    },
                  ]"
                  :disabled="companydisabled"
                  autoSize
                ></a-textarea>
              </a-form-item>
              <a-form-item label="电话">
                <a-textarea :disabled="companydisabled" v-decorator="['tel']" autoSize></a-textarea>
              </a-form-item>
              <a-form-item label="联系人电话">
                <a-textarea
                  :disabled="companydisabled"
                  v-decorator="['contact_tel']"
                  autoSize
                ></a-textarea>
              </a-form-item>
            </a-form>
          </div>
        </a-spin>
      </div>
    </div>
    <PasswdForm
      :phone="info.phone_number"
      :id="info.id"
      :visible="visible"
      @cancel="visible = false"
    ></PasswdForm>
  </div>
</template>
<script>
  import Menu from '@/views/admin/menu/index.vue';
  import Upload from '@/components/Upload/index';
  import { userinfo, idCardOcr, user_info } from '@/api/user';
  import { pick } from 'lodash';
  import PasswdForm from './module/passwdForm.vue';
  import { licenseocr, cert_ocr, companySave } from '@/api/company';
  import { user_company } from '@/api/user';
  import store from '@/store/index';
  export default {
    components: { Menu, Upload, PasswdForm },
    data() {
      return {
        info: {},
        companyinfo: {},
        disabled: false,
        companydisabled: false,
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        form: this.$form.createForm(this, { name: 'company' }),
        companyform: this.$form.createForm(this, { name: 'company2' }),
        spinning: false,
        btnLoading: false,
        visible: false,
        store: store,
      };
    },
    activated() {
      this.getInfo();
    },
    watch: {
      info(a) {
        if (a.id) {
          setTimeout(() => {
            this.form.setFieldsValue(a);
          }, 10);
          this.disabled = true;
        } else {
          this.disabled = false;
          setTimeout(() => {
            this.form.resetFields();
          }, 10);
        }
      },
      companyinfo(a) {
        if (a.id) {
          let companyinfo = Object.assign({}, a, { name: a.owner });
          // console.log(info);
          setTimeout(() => {
            this.companyform.setFieldsValue(companyinfo);
          }, 10);
          this.companydisabled = true;
        } else {
          this.companydisabled = false;
          setTimeout(() => {
            this.companyform.resetFields();
          }, 10);
        }
      },
    },
    methods: {
      async getInfo() {
        this.spinning = true;
        this.info = (await userinfo()) || {};
        this.companyinfo = (await user_company()) || {};
        this.spinning = false;
      },
      async cardUpload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ id_card: res.pathname }), 1);
          this.info.id_card = res.pathname;
          this.info.id_card_id = res.id;
          let ocrres = await idCardOcr({ id: res.id, side: 'front' });
          let ocrrespick = pick(ocrres, [
            'province',
            'city',
            'district',
            'address',
            'id_card_num',
            'birthday',
            'sex',
            'name',
            'id_card_id',
          ]);
          this.info = Object.assign({}, this.info, ocrrespick);
          setTimeout(() => this.form.setFieldsValue({ name: ocrres.name }), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      async companycertUpload(res) {
        try {
          setTimeout(() => this.companyform.setFieldsValue({ certificate_src: res.pathname }), 1);
          let ocrres = await cert_ocr(res.id);
          let ocrrespick = pick(ocrres, ['bankAccount', 'bankName']);
          ocrrespick.name = ocrres.owner;
          setTimeout(() => this.companyform.setFieldsValue(ocrrespick), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      async cardBackUpload(res) {
        try {
          setTimeout(() => this.form.setFieldsValue({ id_card_back: res.pathname }), 1);
          this.info.id_card_back_id = res.id;
          this.info.id_card_back = res.pathname;
        } catch (error) {
          this.$message.error(error);
        }
      },
      async licenseUpload(res) {
        // console.log(res);
        try {
          setTimeout(() => this.companyform.setFieldsValue({ license: res.pathname }), 1);
          let ocrres = await licenseocr(res.id);
          let ocrrespick = pick(ocrres, ['address', 'taxNumber', 'owner', 'legal_person']);
          setTimeout(() => this.companyform.setFieldsValue(ocrrespick), 1);
        } catch (error) {
          this.$message.error(error);
        }
      },
      async submit(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            try {
              this.spinning = true;
              this.btnLoading = true;
              let data = Object.assign(this.info, values);
              data.review = 1;
              await user_info(data);
              this.$store.dispatch('user/getUserInfoAction');
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.getInfo();
              this.spinning = false;
              this.btnLoading = false;
            }
          }
        });
      },
      qUpload(res) {
        setTimeout(() => this.companyform.setFieldsValue({ qualification_src: res.pathname }), 1);
        this.info.qualification_src = res.pathname;
      },
      async companysubmit(e) {
        e.preventDefault();
        this.companyform.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            if (values.name != values.owner) {
              this.$message.warning('开户许可证和营业执照不匹配,请重新上传');
              return;
            }
            try {
              this.spinning = true;
              this.btnLoading = true;
              let data = Object.assign(this.companyinfo, values);
              data.is_self = true;
              await companySave(data);
              this.$store.dispatch('user/getUserInfoAction');
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.getInfo();
              this.spinning = false;
              this.btnLoading = false;
            }
          } else {
            console.log(values);
          }
        });
      },
      async cancel() {
        await this.getInfo();
        this.disabled = true;
        this.companydisabled = true;
      },
    },
  };
</script>
